import * as React from "react"

const margin = 20

export default class Tooltip extends React.Component<Props> {
	private tooltipHeight: number | null = null
	private tooltipWidth: number | null = null

	constructor(props:Readonly<Props>) {
		super(props)
	}

	render() {
		const mouseMove = this.props.mouseMove
		let left = 0
		let top = 0

		if (mouseMove && mouseMove.currentTarget) {
			const element = mouseMove.currentTarget as HTMLElement
			const rect = element.getBoundingClientRect()
			const tooltipCenter = this.tooltipWidth / 2

			left = mouseMove.clientX - rect.left - tooltipCenter
			top = mouseMove.clientY - rect.top - this.tooltipHeight - 4

			const bodyWidth = document.body.offsetWidth

			if (rect.left + left + this.tooltipWidth + margin >= bodyWidth)
				left = bodyWidth - rect.left - this.tooltipWidth - margin

			if (rect.top <= margin - top)
				top = margin - rect.top
		}

		return <div className="tooltip"
		style={{ left: `${left}px`, top: `${top}px` }}
		ref={div => this.handleTooltipRef(div)}>
			{this.props.message}
		</div>
	}

	private handleTooltipRef(div: HTMLDivElement): void {
		if (div) {
			this.tooltipHeight = div.offsetHeight
			this.tooltipWidth = div.offsetWidth
		}
	}
}

export interface Props {
	message: string
	mouseMove: MouseEvent | null
}



// WEBPACK FOOTER //
// ./src/component/tooltip/index.tsx